"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TreeSet = _interopRequireDefault(require("../../../../java/util/TreeSet"));

var _Geometry2 = _interopRequireDefault(require("./Geometry"));

var _Arrays = _interopRequireDefault(require("../../../../java/util/Arrays"));

var _CoordinateFilter = _interopRequireDefault(require("./CoordinateFilter"));

var _hasInterface = _interopRequireDefault(require("../../../../hasInterface"));

var _IllegalArgumentException = _interopRequireDefault(require("../../../../java/lang/IllegalArgumentException"));

var _GeometryComponentFilter = _interopRequireDefault(require("./GeometryComponentFilter"));

var _Dimension = _interopRequireDefault(require("./Dimension"));

var _GeometryFilter = _interopRequireDefault(require("./GeometryFilter"));

var _CoordinateSequenceFilter = _interopRequireDefault(require("./CoordinateSequenceFilter"));

var _Envelope = _interopRequireDefault(require("./Envelope"));

var _Assert = _interopRequireDefault(require("../util/Assert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var GeometryCollection =
/*#__PURE__*/
function (_Geometry) {
  _inherits(GeometryCollection, _Geometry);

  function GeometryCollection() {
    var _this;

    _classCallCheck(this, GeometryCollection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GeometryCollection).call(this));
    GeometryCollection.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(GeometryCollection, [{
    key: "computeEnvelopeInternal",
    value: function computeEnvelopeInternal() {
      var envelope = new _Envelope.default();

      for (var i = 0; i < this._geometries.length; i++) {
        envelope.expandToInclude(this._geometries[i].getEnvelopeInternal());
      }

      return envelope;
    }
  }, {
    key: "getGeometryN",
    value: function getGeometryN(n) {
      return this._geometries[n];
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      var coordinates = new Array(this.getNumPoints()).fill(null);
      var k = -1;

      for (var i = 0; i < this._geometries.length; i++) {
        var childCoordinates = this._geometries[i].getCoordinates();

        for (var j = 0; j < childCoordinates.length; j++) {
          k++;
          coordinates[k] = childCoordinates[j];
        }
      }

      return coordinates;
    }
  }, {
    key: "getArea",
    value: function getArea() {
      var area = 0.0;

      for (var i = 0; i < this._geometries.length; i++) {
        area += this._geometries[i].getArea();
      }

      return area;
    }
  }, {
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === "number" && arguments[0] instanceof _Geometry2.default) {
        var other = arguments[0],
            tolerance = arguments[1];

        if (!this.isEquivalentClass(other)) {
          return false;
        }

        var otherCollection = other;

        if (this._geometries.length !== otherCollection._geometries.length) {
          return false;
        }

        for (var i = 0; i < this._geometries.length; i++) {
          if (!this._geometries[i].equalsExact(otherCollection._geometries[i], tolerance)) {
            return false;
          }
        }

        return true;
      } else return _get(_getPrototypeOf(GeometryCollection.prototype), "equalsExact", this).apply(this, arguments);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      for (var i = 0; i < this._geometries.length; i++) {
        this._geometries[i].normalize();
      }

      _Arrays.default.sort(this._geometries);
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (this.isEmpty()) return null;
      return this._geometries[0].getCoordinate();
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      var dimension = _Dimension.default.FALSE;

      for (var i = 0; i < this._geometries.length; i++) {
        dimension = Math.max(dimension, this._geometries[i].getBoundaryDimension());
      }

      return dimension;
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return _Geometry2.default.TYPECODE_GEOMETRYCOLLECTION;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      var dimension = _Dimension.default.FALSE;

      for (var i = 0; i < this._geometries.length; i++) {
        dimension = Math.max(dimension, this._geometries[i].getDimension());
      }

      return dimension;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      var sum = 0.0;

      for (var i = 0; i < this._geometries.length; i++) {
        sum += this._geometries[i].getLength();
      }

      return sum;
    }
  }, {
    key: "getNumPoints",
    value: function getNumPoints() {
      var numPoints = 0;

      for (var i = 0; i < this._geometries.length; i++) {
        numPoints += this._geometries[i].getNumPoints();
      }

      return numPoints;
    }
  }, {
    key: "getNumGeometries",
    value: function getNumGeometries() {
      return this._geometries.length;
    }
  }, {
    key: "reverse",
    value: function reverse() {
      var n = this._geometries.length;
      var revGeoms = new Array(n).fill(null);

      for (var i = 0; i < this._geometries.length; i++) {
        revGeoms[i] = this._geometries[i].reverse();
      }

      return this.getFactory().createGeometryCollection(revGeoms);
    }
  }, {
    key: "compareToSameClass",
    value: function compareToSameClass() {
      if (arguments.length === 1) {
        var o = arguments[0];
        var theseElements = new _TreeSet.default(_Arrays.default.asList(this._geometries));
        var otherElements = new _TreeSet.default(_Arrays.default.asList(o._geometries));
        return this.compare(theseElements, otherElements);
      } else if (arguments.length === 2) {
        var _o = arguments[0],
            comp = arguments[1];
        var gc = _o;
        var n1 = this.getNumGeometries();
        var n2 = gc.getNumGeometries();
        var i = 0;

        while (i < n1 && i < n2) {
          var thisGeom = this.getGeometryN(i);
          var otherGeom = gc.getGeometryN(i);
          var holeComp = thisGeom.compareToSameClass(otherGeom, comp);
          if (holeComp !== 0) return holeComp;
          i++;
        }

        if (i < n1) return 1;
        if (i < n2) return -1;
        return 0;
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      if ((0, _hasInterface.default)(arguments[0], _CoordinateFilter.default)) {
        var filter = arguments[0];

        for (var i = 0; i < this._geometries.length; i++) {
          this._geometries[i].apply(filter);
        }
      } else if ((0, _hasInterface.default)(arguments[0], _CoordinateSequenceFilter.default)) {
        var _filter = arguments[0];
        if (this._geometries.length === 0) return null;

        for (var i = 0; i < this._geometries.length; i++) {
          this._geometries[i].apply(_filter);

          if (_filter.isDone()) {
            break;
          }
        }

        if (_filter.isGeometryChanged()) this.geometryChanged();
      } else if ((0, _hasInterface.default)(arguments[0], _GeometryFilter.default)) {
        var _filter2 = arguments[0];

        _filter2.filter(this);

        for (var i = 0; i < this._geometries.length; i++) {
          this._geometries[i].apply(_filter2);
        }
      } else if ((0, _hasInterface.default)(arguments[0], _GeometryComponentFilter.default)) {
        var _filter3 = arguments[0];

        _filter3.filter(this);

        for (var i = 0; i < this._geometries.length; i++) {
          this._geometries[i].apply(_filter3);
        }
      }
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      this.checkNotGeometryCollection(this);

      _Assert.default.shouldNeverReachHere();

      return null;
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return _Geometry2.default.TYPENAME_GEOMETRYCOLLECTION;
    }
  }, {
    key: "copy",
    value: function copy() {
      var geometries = new Array(this._geometries.length).fill(null);

      for (var i = 0; i < geometries.length; i++) {
        geometries[i] = this._geometries[i].copy();
      }

      return new GeometryCollection(geometries, this._factory);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      for (var i = 0; i < this._geometries.length; i++) {
        if (!this._geometries[i].isEmpty()) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryCollection;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return GeometryCollection;
}(_Geometry2.default);

exports.default = GeometryCollection;

GeometryCollection.constructor_ = function () {
  this._geometries = null;

  if (arguments.length === 0) {} else if (arguments.length === 2) {
    var geometries = arguments[0],
        factory = arguments[1];

    _Geometry2.default.constructor_.call(this, factory);

    if (geometries === null) {
      geometries = [];
    }

    if (_Geometry2.default.hasNullElements(geometries)) {
      throw new _IllegalArgumentException.default("geometries must not contain null elements");
    }

    this._geometries = geometries;
  }
};

GeometryCollection.serialVersionUID = -5694727726395021467;